import React from "react";
import { PDPADuplicateFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Buttons, Inputs } from "components";

const PDPADuplicateForm = ({ options, onCancel, onSubmit }) => {
  const schema = yup.object().shape({
    pdpa: yup.object().nullable().required("Required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <PDPADuplicateFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form_title">Clone PDPA</div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.InputMultiSelect
                {...field}
                options={options}
                placeholder={"กรุณาเลือก PDPA ที่ต้องการ"}
                errors={errors.pdpa?.message}
              />
            )}
            name="pdpa"
          />
        </div>
        <div className="action_row">
          <div className="btn_wrap">
            <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
          </div>
          <div className="btn_wrap">
            <Buttons.BgStandard type="submit" label="Submit" />
          </div>
        </div>
      </form>
    </PDPADuplicateFormStyled>
  );
};

PDPADuplicateForm.propTypes = {};

export default PDPADuplicateForm;
